var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flex flex-col gap-4" },
    [
      _c(
        "div",
        { staticClass: "flex flex-col gap-4 md:flex-row" },
        [
          _c(
            "jade-box",
            { staticClass: "w-full", attrs: { hasPadding: "" } },
            [
              _c(
                "jade-text",
                {
                  attrs: {
                    color: "medium",
                    variant: "text-small",
                    weight: "medium",
                  },
                },
                [_vm._v(_vm._s(_vm.$t("created-charges-tpv")))]
              ),
              _c(
                "jade-text",
                {
                  staticClass: "!mt-1",
                  attrs: { color: "high", variant: "display-small" },
                },
                [_vm._v(_vm._s(_vm.computedTpvValue))]
              ),
            ],
            1
          ),
          _c(
            "jade-box",
            { staticClass: "w-full", attrs: { hasPadding: "" } },
            [
              _c(
                "jade-text",
                {
                  attrs: {
                    color: "medium",
                    variant: "text-small",
                    weight: "medium",
                  },
                },
                [_vm._v(_vm._s(_vm.$t("total-authorized-volume")))]
              ),
              _c(
                "jade-text",
                {
                  staticClass: "!mt-1",
                  attrs: { color: "high", variant: "display-small" },
                },
                [_vm._v(_vm._s(_vm.computedAuthorizedTpvValue))]
              ),
            ],
            1
          ),
          _c(
            "jade-box",
            { staticClass: "w-full", attrs: { hasPadding: "" } },
            [
              _c(
                "jade-text",
                {
                  attrs: {
                    color: "medium",
                    variant: "text-small",
                    weight: "medium",
                  },
                },
                [_vm._v(_vm._s(_vm.$t("charges-amount")))]
              ),
              _c(
                "jade-text",
                {
                  staticClass: "!mt-1",
                  attrs: { color: "high", variant: "display-small" },
                },
                [_vm._v(_vm._s(_vm.computedSalesLabel))]
              ),
            ],
            1
          ),
          _c(
            "jade-box",
            { staticClass: "w-full", attrs: { hasPadding: "" } },
            [
              _c(
                "div",
                { staticClass: "flex gap-1" },
                [
                  _c(
                    "jade-text",
                    {
                      attrs: {
                        color: "medium",
                        variant: "text-small",
                        weight: "medium",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("ticket")) + " ")]
                  ),
                  _c(
                    "jade-tooltip",
                    {
                      attrs: {
                        text: _vm.$t("tippy-ticket"),
                        placement: "top-start",
                      },
                    },
                    [
                      _c("jade-icon", {
                        attrs: { use: "circle-info", size: "small" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "jade-text",
                {
                  staticClass: "!mt-1",
                  attrs: { color: "high", variant: "display-small" },
                },
                [_vm._v(_vm._s(_vm.computedAverageTicket))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "jade-box",
        {
          attrs: { title: _vm.$t("charges.chat"), hasPadding: "" },
          scopedSlots: _vm._u([
            {
              key: "action",
              fn: function () {
                return [
                  _c(
                    "jade-dropdown",
                    {
                      attrs: { open: _vm.dropdownOpen, alignment: "end" },
                      on: {
                        closePopover: function ($event) {
                          _vm.dropdownOpen = false
                        },
                        toggleOpen: _vm.toggleOpen,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "trigger",
                          fn: function () {
                            return [
                              _c(
                                "jade-action-button",
                                {
                                  attrs: {
                                    icon: "chart-bar",
                                    dropdownIndicator: "",
                                    active: "",
                                  },
                                },
                                [_vm._v(_vm._s(_vm.activeChart.label))]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _vm._l(_vm.chargeChartOptions, function (option) {
                        return _c("jade-list-item", {
                          key: option.value,
                          attrs: {
                            variant:
                              _vm.activeChart.value === option.value
                                ? "active"
                                : "primary",
                            label: option.label,
                            as: "button",
                          },
                          on: {
                            onClick: function ($event) {
                              return _vm.toogleTypeChart(option.value)
                            },
                          },
                        })
                      }),
                    ],
                    2
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "dash-card-content-fallback",
            { attrs: { hasData: _vm.hasData } },
            [
              _c("chart-line-charges", {
                attrs: { type: _vm.typeChart, data: _vm.data },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }